import * as React from "react";
import { TemplateSub } from "../../components/layouts/TemplateSub";

export const AboutUsPage: React.FC = () => {
  return (
    <TemplateSub page="About Us">
      <div className="px-4">
        <div className="flex flex-col mt-[1rem] h-[calc(100vh-180px)] bg-[#1E1E1E] rounded-xl overflow-hidden">
          {/* Scrollable content area */}
          <div className="overflow-y-auto p-6">
            <div className="mb-6">
              <h1 className="text-[20px] font-bold text-white mb-4">
                About Njoy
              </h1>
              <p className="text-white text-[16px] opacity-80">
                Redefining everyday value through a seamless digital experience.
              </p>
            </div>

            <div className="mb-6">
              <h2 className="text-[18px] font-bold text-white mb-2">
                Our Mission
              </h2>
              <p className="text-white mb-6 opacity-80">
                Njoy is a mobile-first digital lifestyle platform built to
                support how you live, move, and connect. It brings curated
                perks, essential services, and shared opportunities into one
                simple place. You get more for less, with real savings on the
                things you do every day.
              </p>
            </div>

            <ol className="list-decimal pl-6 space-y-8 mb-6">
              {/* Section 1 */}
              <li className="pl-2 text-white">
                <h2 className="text-[16px] font-semibold mb-2 text-white">
                  Built for You
                </h2>
                <p className="text-white opacity-80">
                  Built for the digital generation. No jargon, no paperwork, no
                  barriers. Just real, everyday access to what matters most to
                  you.
                </p>
              </li>
              {/* Section 2 */}
              <li className="pl-2 text-white">
                <h2 className="text-[16px] font-semibold mb-2 text-white">
                  Curated Value
                </h2>
                <p className="text-white opacity-80">
                  From food and groceries to transport, wellness to shopping.
                  Njoy curates perks and services that enhance daily life, not
                  distract from it.
                </p>
              </li>
              {/* Section 3 */}
              <li className="pl-2 text-white ">
                <h2 className="text-[16px] font-semibold mb-2 text-white">
                  Connecting Communities
                </h2>
                <p className="text-white opacity-80">
                  We engage Nigeria's most connected generation and reward
                  loyalty through tools that drive advocacy, visibility, and
                  real growth for partners.
                </p>
              </li>
            </ol>
            <div className="text-white mb-8">
              <p className="text-white text-[18px]">
                {" "}
                Ready to Experience Njoy?
              </p>

              <p className="text-white opacity-80">
                Join thousands of users who are already enjoying curated perks
                and essential services in one simple platform.{" "}
                <a
                  href="https://njoy.live/#about-njoy"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-indigo-400 hover:underline"
                >
                  Learn More
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </TemplateSub>
  );
};
